var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"mt-2 newsImg",attrs:{"cols":"12","lg":"4","md":"4","sm":"12"}},[_c('a',{attrs:{"href":_vm.pathA,"target":"_blank"}},[_c('v-img',{staticClass:"mx-lg-0 mx-md-0 mx-sm-auto",attrs:{"src":_vm.pathImg,"aspect-ratio":"2"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }